import { Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TourController } from '../../engine/tour-controller.service';

/**
 * Shown when a tour finishes — the web port of Flutter's
 * `TourCompletionDialog`. Driven entirely by `TourController.completion()`.
 */
@Component({
  selector: 'app-tour-completion-dialog',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tour-completion-dialog.component.html',
  styleUrl: './tour-completion-dialog.component.scss',
})
export class TourCompletionDialogComponent {
  controller = inject(TourController);

  readonly tour = computed(() => this.controller.completion());
  readonly accent = computed(() => this.tour()?.accentColor ?? '#007AFF');

  onReplay(): void {
    this.controller.replay();
  }
  onBrowse(): void {
    this.controller.browseMore();
  }
  onDone(): void {
    this.controller.dismissCompletion();
  }
}
